module.exports = __webpack_public_path__ + "img/checkedbox.0ad0a2e8.svg";